// @flow

import type { SocialSettings, SocialState } from './types';
import type { State as RoutesState } from '../routes/types';
import { getBusinessLabel } from '../routes';
import type { State as RouterState } from '../router';

type GlobalState = {
  socialSettings: SocialState,
  routes: RoutesState,
  router: RouterState,
};

export default (state: GlobalState): SocialSettings => {
  const { socialSettings } = state;
  const label = getBusinessLabel(state) !== '' ? getBusinessLabel(state) : 'default';
  if (!socialSettings || !socialSettings[label]) {
    throw new Error('Missing socialSettings store.');
  }
  return socialSettings[label];
};
